export enum LogType {
    DEFAULT,
    WARNING,
    ERROR,
}
